import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RedirectionService {
  constructor(private router: Router) {
    // const currentUrl = window.location.href;
    // if (currentUrl == 'https://sgbojio.com/#/') {
    //   window.location.href = 'https://sgbojio.com/#/marketplace';
    // }
    // if (currentUrl == 'https://corporatepromo.sg/#/') {
    //   window.location.href = 'https://corporatepromo.sg/#/portal';
    // }
    // if (
    //   window.location.hostname.includes('kachiing') &&
    //   !window.location.hostname.includes('policies')
    // ) {
    //   //Refresh Page and keep on same page
    // }
    // if (
    //   window.location.hostname.includes('sgbojio') &&
    //   !window.location.hostname.includes('policies')
    // ) {
    //   this.router.navigate(['/community']);
    // }
  }
}
